import { render, staticRenderFns } from "./add_update_contact_modal.vue?vue&type=template&id=047d1280&scoped=true"
import script from "./add_update_contact_modal.vue?vue&type=script&lang=js"
export * from "./add_update_contact_modal.vue?vue&type=script&lang=js"
import style0 from "./add_update_contact_modal.vue?vue&type=style&index=0&id=047d1280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d1280",
  null
  
)

export default component.exports